import React from 'react';

interface Props {
  href: string;
  onLoad: any;
}

export const Stylesheet = (props: Props) => {
  const { href, onLoad } = props;
  return (
    <link
      rel="stylesheet"
      type="text/css"
      href={href}
      media="print"
      onLoad={onLoad}
    />
  );
};
